import React, { useState } from 'react';
import { useParallax } from 'react-scroll-parallax';

const Card = ({ children, className = '', style = {}, delay = 0, colorTheme = '' }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const cardParallax = useParallax({
    translateY: [30, 0, "easeOutQuad"],
    opacity: [0.3, 1, "easeOutQuad"],
    scale: [0.95, 1, "easeOutQuad"],
    shouldAlwaysCompleteAnimation: true,
    expanded: false,
    startScroll: 100 + delay
  });

  // Define color themes for different business solutions
  const getColorStyles = () => {
    switch (colorTheme) {
      case 'supply-chain':
        return {
          background: isHovered 
            ? 'rgba(37, 99, 235, 0.35)' 
            : 'rgba(37, 99, 235, 0.25)',
          boxShadow: isHovered 
            ? '0 15px 35px rgba(0, 0, 0, 0.25), 0 0 15px rgba(59, 130, 246, 0.5)' 
            : '0 8px 32px rgba(0, 0, 0, 0.2), 0 0 10px rgba(59, 130, 246, 0.2)',
          border: isHovered 
            ? '1px solid rgba(96, 165, 250, 0.4)' 
            : '1px solid rgba(96, 165, 250, 0.2)'
        };
      case 'manufacturing':
        return {
          background: isHovered 
            ? 'rgba(124, 58, 237, 0.35)' 
            : 'rgba(124, 58, 237, 0.25)',
          boxShadow: isHovered 
            ? '0 15px 35px rgba(0, 0, 0, 0.25), 0 0 15px rgba(139, 92, 246, 0.5)' 
            : '0 8px 32px rgba(0, 0, 0, 0.2), 0 0 10px rgba(139, 92, 246, 0.2)',
          border: isHovered 
            ? '1px solid rgba(167, 139, 250, 0.4)' 
            : '1px solid rgba(167, 139, 250, 0.2)'
        };
      case 'sales':
        return {
          background: isHovered 
            ? 'rgba(234, 179, 8, 0.35)' 
            : 'rgba(234, 179, 8, 0.25)',
          boxShadow: isHovered 
            ? '0 15px 35px rgba(0, 0, 0, 0.25), 0 0 15px rgba(250, 204, 21, 0.5)' 
            : '0 8px 32px rgba(0, 0, 0, 0.2), 0 0 10px rgba(250, 204, 21, 0.2)',
          border: isHovered 
            ? '1px solid rgba(253, 224, 71, 0.4)' 
            : '1px solid rgba(253, 224, 71, 0.2)'
        };
      case 'retail':
        return {
          background: isHovered 
            ? 'rgba(249, 115, 22, 0.35)' 
            : 'rgba(249, 115, 22, 0.25)',
          boxShadow: isHovered 
            ? '0 15px 35px rgba(0, 0, 0, 0.25), 0 0 15px rgba(251, 146, 60, 0.5)' 
            : '0 8px 32px rgba(0, 0, 0, 0.2), 0 0 10px rgba(251, 146, 60, 0.2)',
          border: isHovered 
            ? '1px solid rgba(253, 186, 116, 0.4)' 
            : '1px solid rgba(253, 186, 116, 0.2)'
        };
      default:
        return {
          background: isHovered 
            ? 'rgba(255, 255, 255, 0.25)' 
            : 'rgba(255, 255, 255, 0.2)',
          boxShadow: isHovered 
            ? '0 15px 35px rgba(0, 0, 0, 0.25), 0 0 15px rgba(59, 130, 246, 0.3)' 
            : '0 8px 32px rgba(0, 0, 0, 0.2)',
          border: isHovered 
            ? '1px solid rgba(255, 255, 255, 0.25)' 
            : '1px solid rgba(255, 255, 255, 0.15)'
        };
    }
  };

  const colorStyles = getColorStyles();

  const cardStyle = {
    willChange: 'transform, opacity',
    opacity: 1,
    transform: isHovered ? 'translateY(-10px) scale(1.03)' : 'translateY(0%) scale(1)',
    transition: 'transform 0.3s ease, opacity 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
    padding: '1rem',
    borderRadius: '12px',
    backdropFilter: 'blur(12px)',
    ...colorStyles,
    ...style
  };

  return (
    <div 
      ref={cardParallax.ref}
      className={`animated-card ${className}`}
      style={cardStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  );
};

export default Card;
